import { Flex, Box, Text, Spacer, Grid, GridItem } from "@chakra-ui/layout";
import { Select, Button, ButtonGroup } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { AddCard } from "../Components/AddCard";
import { AddTcCard } from "../Components/AddTcCard";
import { AddProcurementCard } from "../Components/AddProcurementCard";
import { ListCard } from "../Components/ListCard";
import MetricCard from "../Components/MetricCard";
import { unwrapResult } from "@reduxjs/toolkit";
import { menuItems } from "../Constant";
import { useNavigate } from "react-router-dom";
import { getCompanyDetails } from "../redux/company/CompanySlice";
import { useEffect, useState } from "react";
import { getMetric } from "../api";
import { IncomingTcCard } from "../Components/IncomingTcCard";
import { PendingTcCard } from "../Components/PendingTcCard";

function Home(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.auth);
  const { companyDetails } = useSelector((state) => state.company);

  const [selectedRole, setSelectedRole] = useState("GINNER");

  const handleRoleChange = (role) => {
    setSelectedRole(role);
  };

  const [selectedUnit, setSelectedUnit] = useState(
    companyDetails?.data?.company_units?.[0]?.id || null
  );
  const [metrics, setMetrics] = useState({});

  const getCompany = () => {
    try {
      const result = dispatch(getCompanyDetails(userData?.companyId));
      unwrapResult(result);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleUnitChange = async (unitId) => {
    try {
      setSelectedUnit(
        companyDetails.data?.company_units?.find((unit) => unit._id === unitId)
      );
      const metrics = await getMetric(unitId);
      setMetrics(metrics);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (selectedUnit?._id) {
      handleUnitChange(selectedUnit._id);
    }
  }, []);

  useEffect(() => {
    if (selectedUnit?._id) {
      handleUnitChange(selectedUnit._id);
    } else if (companyDetails?.data?.company_units?.length) {
      const mainUnit = companyDetails.data.company_units.find(
        (unit) => unit.unitType === "MAIN"
      );

      if (mainUnit) {
        handleUnitChange(mainUnit._id);
      } else {
        const firstUnitId = companyDetails.data.company_units[0]._id;
        handleUnitChange(firstUnitId);
      }
    }
  }, [selectedUnit, companyDetails?.data?.company_units]);

  const getMetrics = async (unitId) => {
    const response = await getMetric(unitId);
    return response?.data;
  };

  // useEffect(() => {
  //   getCompany();
  //   getMetrics();
  // }, []);

  // useEffect(() => {
  //   if (companyDetails) {
  //     getCompany();
  //     getMetrics();
  //   }
  // }, []);

  useEffect(() => {
    if (selectedUnit?._id) {
      getMetrics(selectedUnit._id);
    }
  }, []);

  useEffect(() => {
    if (userData?.companyId || companyDetails) {
      getCompany();
    }
  }, [userData]);

  //   const [cachedMetrics, setCachedMetrics] = useState({});

  // const getMetrics = async (unitId) => {
  //   if (cachedMetrics[unitId]) {
  //     return cachedMetrics[unitId];
  //   } else {
  //     const response = await getMetric(unitId);
  //     const metricsData = response?.data;
  //     setCachedMetrics((prevCachedMetrics) => ({
  //       ...prevCachedMetrics,
  //       [unitId]: metricsData,
  //     }));
  //     return metricsData;
  //   }
  // };

  // // ...

  // useEffect(() => {
  //   if (selectedUnit?._id) {
  //     getMetrics(selectedUnit._id);
  //   }
  // }, [selectedUnit]);

  const filteredMenu = menuItems.filter((menu) => {
    return menu?.visibleTo?.some((item) => userData?.role?.includes(item));
  });

  if (
    userData?.role &&
    !(
      userData?.role?.includes("GINNER") ||
      userData?.role?.includes("NONGINNER")
    )
  ) {
    // Change to 0 instead of 1
    return <Navigate to={`${filteredMenu[0].path}`} />;
  }

  return (
    <Box paddingTop={"3.5rem"}>
      <Flex gap={"10"} alignItems={"center"} marginBottom={"2rem"}>
        <Box>
          <Text color={"#141D43"} fontSize="2xl" fontWeight={"800"}>
            Welcome User
          </Text>
          <Text color={" #3958DC"} fontSize="sm">
            Analytics and Insights
          </Text>
        </Box>
        <Box>
          <Select
            w="280px"
            h="40px"
            bg="brand.white"
            borderRadius="10px"
            onChange={(e) => handleUnitChange(e.target.value)}
            value={selectedUnit?._id}
          >
            <option hidden="true">Select Unit</option>
            {companyDetails?.data?.company_units?.map((unit) => (
              <option key={unit._id} value={unit._id}>
                {" "}
                {unit.name}
              </option>
            ))}
          </Select>
        </Box>
        <Box>
          <Button
            onClick={() => navigate("/client/transaction-certificates/tc-form")}
            color="brand.white"
            bg="brand.secondaryColor"
            colorScheme="brand.secondaryColor"
          >
            Add TC
          </Button>
        </Box>
      </Flex>
      <MetricCard metrics={metrics} />

      <Box>
        <Box mt="2rem" p="1rem">
          {userData?.role?.includes("GINNER") &&
          userData?.role?.includes("NONGINNER") ? (
            <Box>
              <ButtonGroup gap={2}>
                <Button
                  bg={selectedRole === "GINNER" ? "#52BBFF" : "white"}
                  onClick={() => handleRoleChange("GINNER")}
                >
                  Ginner
                </Button>
                <Button
                  bg={selectedRole === "NONGINNER" ? "#52BBFF" : "white"}
                  onClick={() => handleRoleChange("NONGINNER")}
                >
                  Non-Ginner
                </Button>
              </ButtonGroup>
            </Box>
          ) : null}
        </Box>

        {userData?.role?.includes("GINNER") && selectedRole === "GINNER" ? (
          <Grid
            templateColumns={{
              base: "1fr",
              md: "2fr",
              lg: "repeat(3, 1fr)",
            }}
          >
            <GridItem>
              <ListCard tempId="1" />
            </GridItem>
            <GridItem>
              <Flex flexDirection={"column"}>
                <AddCard />
                <Spacer />
                <AddProcurementCard />
              </Flex>
            </GridItem>
            <GridItem>
              <PendingTcCard />
            </GridItem>
          </Grid>
        ) : null}

        {userData?.role?.includes("NONGINNER") &&
        selectedRole === "NONGINNER" ? (
          <Grid
            templateColumns={{
              base: "1fr",
              md: "2fr",
              lg: "repeat(3, 1fr)",
            }}
          >
            <GridItem>
              <IncomingTcCard />
            </GridItem>
            <GridItem>
              <Flex flexDirection={"column"}>
                <AddTcCard />
                <Spacer />
              </Flex>
            </GridItem>
            <GridItem>
              <PendingTcCard />
            </GridItem>
          </Grid>
        ) : null}

        {userData?.role?.includes("NONGINNER") &&
        !userData?.role?.includes("GINNER") &&
        selectedRole !== "NONGINNER" ? (
          <Grid
            templateColumns={{
              base: "1fr",
              md: "2fr",
              lg: "repeat(3, 1fr)",
            }}
          >
            <GridItem>
              <IncomingTcCard />
            </GridItem>
            <GridItem>
              <Flex flexDirection={"column"}>
                <AddTcCard />
                <Spacer />
              </Flex>
            </GridItem>
            <GridItem>
              <PendingTcCard />
            </GridItem>
          </Grid>
        ) : null}

        {userData?.role?.includes("GINNER") &&
        !userData?.role?.includes("NONGINNER") &&
        selectedRole !== "GINNER" ? (
          <Grid
            templateColumns={{
              base: "1fr",
              md: "2fr",
              lg: "repeat(3, 1fr)",
            }}
          >
            <GridItem>
              <ListCard tempId="1" />
            </GridItem>
            <GridItem>
              <Flex flexDirection={"column"}>
                <AddCard />
                <Spacer />
                <AddProcurementCard />
              </Flex>
            </GridItem>
            <GridItem>
              <PendingTcCard />
            </GridItem>
          </Grid>
        ) : null}
      </Box>
    </Box>
  );
}

export default Home;
